
<div class="tds-row">
  <h4 class="tds-u-pl1">
    Give dispensation for an assignment to be ongoing for more then two years.<br> 
    The assignment will no longer get reminder emails.
  </h4>
  <div class="tds-col-xs-6">
    <tds-text-field [(ngModel)]="assignmentNumber" ngDefaultControl size="md" label="Assignment Number" label-position="inside"
      no-min-width placeholder="Enter Assignment Number">
    </tds-text-field>
  </div>
  <div class="tds-col-xs-4">
    <tds-button type="submit" variant="primary" size="md" [disabled]="isDataNotSet()" text="Submit" (click)="giveDispensation()">
      <tds-icon slot="icon" class="tds-btn-icon" size="20px" name="send"></tds-icon>
    </tds-button>
  </div>
</div>


<h4 class="tds-u-pl1" *ngIf="assignmentNumbersWithDispensation.length > 0">
  Current Assignments with dispensation
</h4>

<div style="overflow-y: scroll;height: 300px;" class="tds-u-pl1">
  <tds-table *ngIf="assignmentNumbersWithDispensation.length > 0" vertical-dividers="false" compact-design="true" responsive="true" no-min-width>
    <tds-table-header>
      <tds-header-cell custom-width="90%" column-title="Assignment Number"></tds-header-cell>
      <tds-header-cell column-title="Remove"></tds-header-cell>
    </tds-table-header>

    <tds-table-body>
      <tds-table-body-row *ngFor="let assignmentNr of assignmentNumbersWithDispensation">
        <tds-body-cell class="tds-u-pt3">
          {{ assignmentNr }}
        </tds-body-cell>
        <tds-body-cell>
            <tds-button type="button" variant="danger" size="sm" text="" (click)="removeDispensation(assignmentNr)">
              <tds-icon slot="icon" class="tds-btn-icon" size="16px" name="trash"></tds-icon>
            </tds-button>
        </tds-body-cell>
      </tds-table-body-row>
    </tds-table-body>
  </tds-table>
</div>